import { gstheme } from '../style/gstheme';

export const RTL_REGEX = RegExp(/[\u0600-\u06ff\u0600-\u0674\u0750-\u077f\u0780-\u07bf\u08a0-\u08ff\ufb1d-\ufefe]/g);

export const MEDIA_TYPES = {
    IMAGES: "image/*",
    MATHML: "application/mathml+xml",
    MARKDOWN: "text/markdown",
    MULTILINE: "text/plain",
    HTML: "text/html",
    SVG: "image/svg+xml"
};

export const RANGE_MEDIATYPE_MAPPING = {
    "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString": [
        {
            label: "Multiline text",
            value: MEDIA_TYPES.MULTILINE
        }
    ],
    "http://www.w3.org/2001/XMLSchema#anyURI": [
        {
            label: "Image Link",
            value: MEDIA_TYPES.IMAGES
        }
    ],
    "http://www.w3.org/2001/XMLSchema#string": [
        {
            label: "HTML",
            value: MEDIA_TYPES.HTML
        },
        {
            label: "Image Link",
            value: MEDIA_TYPES.IMAGES
        },
        {
            label: "MathML",
            value: MEDIA_TYPES.MATHML
        },
        {
            label: "Markdown",
            value: MEDIA_TYPES.MARKDOWN
        },
        {
            label: "Multiline text",
            value: MEDIA_TYPES.MULTILINE
        },
        {
            label: "SVG Image",
            value: MEDIA_TYPES.SVG
        }
    ]
};


// By using the same load options as much as possible avoids reloading requests
export const CONCEPT_LOAD_OPTIONS = {
    "predicates": [
        "http://www.w3.org/2004/02/skos/core#inScheme",
        "http://www.w3.org/2004/02/skos/core#prefLabel",
        "http://www.w3.org/2002/07/owl#deprecated",
        "http://purl.org/dc/terms/title",
        "http://www.w3.org/2008/05/skos-xl#prefLabel",
        "http://www.w3.org/2004/02/skos/core#narrower",
        "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        "https://grafsync.graphifi.com/schema/gs/status"
    ],
    "tests": [
        {
            "id": "http://www.w3.org/2008/05/skos-xl#prefLabel",
            "join": [{
                "predicate": "http://www.w3.org/2008/05/skos-xl#literalForm"
            }]
        }
    ]
};

export const CLASS_LOAD_OPTIONS = {
    predicates: [
        "http://www.w3.org/2000/01/rdf-schema#label",
        "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
        "https://grafsync.graphifi.com/schema/gs/visibility",
        "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        "http://www.w3.org/2002/07/owl#deprecated",
    ]
};

export const PACKAGES = {
    "https://graphifi.com/data/package/vocabularyontologymanagement": "Vocabulary and Ontology Management"
};

export const NS_GS = "https://grafsync.graphifi.com/schema/gs/";
export const NS_ACL = "https://graphifi.com/schema/accesscontrol/";
export const USER_NAMESPACE = "https://graphifi.com/data/user/";
export const INVITATION_NAMESPACE = "https://graphifi.com/data/invitation/";
export const PROJECT_NAMESPACE = "https://grafsync.graphifi.com/data/project/";
export const GRAPH_IRI_SYSTEM = "https://grafsync.graphifi.com/graph/system";
export const GRAPH_IRI_SECURITY = "https://grafsync.graphifi.com/graph/security";

export const BN_NAMESPACE = "https://grafsync.graphifi.com/data/bn/";

export const STATUS_ACCEPTED = "https://grafsync.graphifi.com/schema/gs/accepted";
export const STATUS_PENDING = "https://grafsync.graphifi.com/schema/gs/pending";
export const STATUS_REJECTED = "https://grafsync.graphifi.com/schema/gs/rejected";
export const STATUS_DRAFT = "https://grafsync.graphifi.com/schema/gs/draft";

export const OBJECT_RESTRICTION = "OBJECT";
export const DATA_RESTRICTION = "DATA";
export const VARIANT_SOME = "SOME";
export const VARIANT_ALL = "ALL";
export const VARIANT_EXACT = "EXACT";
export const VARIANT_MINIMUM = "MINIMUM";
export const VARIANT_MAXIMUM = "MAXIMUM";

export const PROJECT_COLOURS = [
    gstheme.palette.primary.main.substring(1),
    "50832C",
    "00A9E0",
    "49426A",
    "028090",
    "5D737E",
    gstheme.palette.primary.light.substring(1)
];

export const BCP_47_REGEX = "^(?:(?:[a-z]{2,3}|[a-z]{4,8})(?:-[a-z]{4})?(?:-(?:[a-z]{2}|[0-9]{3}))?(?:-(?:[a-z0-9]{5,8}|[0-9][a-z0-9]{3}))*(?:-(?:[a-wy-z0-9](?:-[a-z0-9]{2,8})+))*)(?:-x(?:-[a-z0-9]{1,8})+)?$|^(?:x(?:-[a-z0-9]{1,8})+)$";

// Derived from https://en.wikipedia.org/wiki/ISO_15924
export const RTL_SCRIPTS = [
    "adlm",
    "arab",
    "aran",
    "armi",
    "avst",
    "chrs",
    "cprt",
    "egyp",
    "elym",
    "gara",
    "hatr",
    "hebr",
    "lydi",
    "mand",
    "mani",
    "mend",
    "merc",
    "mero",
    "narb",
    "nbat",
    "nkoo",
    "orkh",
    "palm",
    "phli",
    "phlp",
    "phnx",
    "prti",
    "rohg",
    "sarb",
    "sidt",
    "sogo",
    "syrc",
    "syre",
    "syrj",
    "syrn",
    "thaa",
    "yezi"
];

// We might need to expand this list over time
export const LTR_SCRIPTS = [
    "afak",
    "aghb",
    "ahom",
    "armn",
    "bali",
    "bamu",
    "bass",
    "batk",
    "beng",
    "berf",
    "cyrl",
    "grek",
    "latn"
];

export const LANGS = {
    und: { en: "No Language" },
    aa: { en: "Afar" },
    ab: { en: "Abkhazian" },
    ae: { en: "Avestan" },
    af: { en: "Afrikaans" },
    ak: { en: "Akan" },
    am: { en: "Amharic" },
    an: { en: "Aragonese" },
    ar: { en: "Arabic", rtl: true },
    as: { en: "Assamese" },
    av: { en: "Avaric" },
    ay: { en: "Aymara" },
    az: { en: "Azerbaijani" },
    ba: { en: "Bashkir" },
    be: { en: "Belarusian" },
    bh: { en: "Bihari" },
    bm: { en: "Bambara" },
    bg: { en: "Bulgarian" },
    bn: { en: "Bengali" },
    bo: { en: "Tibetan" },
    bs: { en: "Bosnian" },
    ca: { en: "Catalan" },
    ce: { en: "Chechen" },
    cr: { en: "Cree" },
    cs: { en: "Czech" },
    cy: { en: "Welsh" },
    cz: { en: "Czech" },
    da: { en: "Danish" },
    de: { en: "German" },
    "de-ch": { en: "German (Switzerland)" },
    dv: { en: "Divehi", rtl: true },
    ew: { en: "Ewe" },
    en: { en: "English" },
    "en-us": { en: "English (American)" },
    "en-au": { en: "English (Australia)" },
    "en-ca": { en: "English (Canada)" },
    "en-gb": { en: "English (British)" },
    "en-nz": { en: "English (New Zealand)" },
    el: { en: "Greek" },
    eo: { en: "Esperanto" },
    es: { en: "Spanish" },
    "es-us": { en: "Spanish (American)" },
    "es-es": { en: "Spanish (Spain)" },
    et: { en: "Estonian" },
    eu: { en: "Basque" },
    fa: { en: "Persian", rtl: true },
    ff: { en: "Fulah" },
    fi: { en: "Finnish" },
    fj: { en: "Fijian" },
    fo: { en: "Faroese" },
    fr: { en: "French" },
    "fr-be": { en: "French (Belgium)" },
    "fr-ca": { en: "French (Canada)" },
    "fr-fr": { en: "French (France)" },
    "fr-lu": { en: "French (Luxembourg)" },
    "fr-ch": { en: "French (Switzerland)" },
    fy: { en: "Western Frisian" },
    ga: { en: "Gaelic" },
    gl: { en: "Galician" },
    gn: { en: "Guarani" },
    gu: { en: "Gujarati" },
    gv: { en: "Manx" },
    ha: { en: "Hausa" },
    he: { en: "Hebrew", rtl: true },
    hi: { en: "Hindi" },
    hr: { en: "Croatian" },
    ht: { en: "Haitian" },
    hu: { en: "Hungarian" },
    hy: { en: "Armenian" },
    hz: { en: "Herero" },
    id: { en: "Indonesian" },
    ig: { en: "Igbo" },
    is: { en: "Icelandic" },
    it: { en: "Italian" },
    ja: { en: "Japanese" },
    jv: { en: "Javanese" },
    ka: { en: "Georgian" },
    kg: { en: "Kongo" },
    kk: { en: "Kazakh" },
    kl: { en: "Greenlandic" },
    km: { en: "Khmer" },
    kn: { en: "Kannada" },
    ko: { en: "Korean" },
    ks: { en: "Kashmiri", rtl: true },
    ku: { en: "Kurdish", rtl: true },
    la: { en: "Latin" },
    lb: { en: "Luxembourgish" },
    lg: { en: "Ganda" },
    ln: { en: "Lingala" },
    lo: { en: "Lao" },
    lt: { en: "Lithuanian" },
    lv: { en: "Latvian" },
    mg: { en: "Malagsay" },
    mk: { en: "Macedonian" },
    mi: { en: "Maori" },
    mh: { en: "Marshallese" },
    ml: { en: "Malayalam" },
    mn: { en: "Mongolian" },
    mr: { en: "Marathi" },
    ms: { en: "Malay" },
    mt: { en: "Maltese" },
    my: { en: "Burmese" },
    na: { en: "Macedonian" },
    nl: { en: "Dutch" },
    "nl-be": { en: "Dutch (Belgium)" },
    "nl-nl": { en: "Dutch (Netherlands)" },
    nb: { en: "Norwegian Bokmål" },
    ne: { en: "Nepali" },
    nn: { en: "Norwegian Nynorsk" },
    no: { en: "Norwegian" },
    ny: { en: "Chichewa" },
    oj: { en: "Ojibwa" },
    om: { en: "Oromo" },
    or: { en: "Oriya" },
    pa: { en: "Punjabi" },
    "pa-in": { en: "Punjabi (India)" },
    "pa-pk": { en: "Punjabi (Pakistan)", rtl: true },
    pl: { en: "Polish" },
    ps: { en: "Pushto", rtl: true },
    pt: { en: "Portuguese" },
    "pt-br": { en: "Portuguese (Brazilian)" },
    "pt-pt": { en: "Portuguese (Portugal)" },
    rn: { en: "Rundi" },
    ro: { en: "Romanian" },
    ru: { en: "Russian" },
    sa: { en: "Samoan" },
    sc: { en: "Sardinian" },
    sd: { en: "Sindhi", rtl: true },
    si: { en: "Sinhala" },
    sk: { en: "Slovak" },
    sl: { en: "Slovenian" },
    sn: { en: "Shona" },
    so: { en: "Somali" },
    sq: { en: "Albanian" },
    sr: { en: "Serbian" },
    st: { en: "Sotho" },
    su: { en: "Sundanese" },
    sv: { en: "Swedish" },
    sw: { en: "Swahili" },
    ta: { en: "Tamil" },
    te: { en: "Telugu" },
    tg: { en: "Tajik" },
    th: { en: "Thai" },
    tk: { en: "Turkmen" },
    tl: { en: "Tagalog" },
    to: { en: "Tonga" },
    tr: { en: "Turkish" },
    tt: { en: "Tatar" },
    ty: { en: "Tahitian" },
    ur: { en: "Urdu", rtl: true },
    uk: { en: "Ukrainian" },
    uz: { en: "Uzbek" },
    vi: { en: "Vietnamese" },
    wo: { en: "Wolof" },
    yi: { en: "Yiddish", rtl: true },
    yo: { en: "Yoruba" },
    zh: { en: "Chinese" },
    "zh-cn": { en: "Chinese (Simplified, China)" },
    "zh-hk": { en: "Chinese (Traditional, Hong Kong)" },
    "zh-sg": { en: "Chinese (Simplified, Singapore)" },
    "zh-tw": { en: "Chinese (Traditional, Taiwan)" },
    zu: { en: "Zulu" }
};

export const DATATYPES = {
    BOOLEAN: "http://www.w3.org/2001/XMLSchema#boolean",
    ANYURI: "http://www.w3.org/2001/XMLSchema#anyURI",
    DATE: "http://www.w3.org/2001/XMLSchema#date",
    DATETIME: "http://www.w3.org/2001/XMLSchema#dateTime",
    STRING: "http://www.w3.org/2001/XMLSchema#string",
    INTEGER: "http://www.w3.org/2001/XMLSchema#integer",
    NNINTEGER: "http://www.w3.org/2001/XMLSchema#nonNegativeInteger",
    DECIMAL: "http://www.w3.org/2001/XMLSchema#decimal",
    DOUBLE: "http://www.w3.org/2001/XMLSchema#double",
    FLOAT: "http://www.w3.org/2001/XMLSchema#float",
    LONG: "http://www.w3.org/2001/XMLSchema#long",
    LANGSTRING: "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString",
};

export const DATATYPE_LABELS = {
    "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString": { en: "Language Tagged String" },
    "http://www.w3.org/2001/XMLSchema#boolean": { en: "Boolean" },
    "http://www.w3.org/2001/XMLSchema#anyURI": { en: "Any URI" },
    "http://www.w3.org/2001/XMLSchema#date": { en: "Date" },
    "http://www.w3.org/2001/XMLSchema#dateTime": { en: "Date/Time" },
    "http://www.w3.org/2001/XMLSchema#string": { en: "String" },
    "http://www.w3.org/2001/XMLSchema#integer": { en: "Integer" },
    "http://www.w3.org/2001/XMLSchema#decimal": { en: "Decimal" },
    "http://www.w3.org/2001/XMLSchema#double": { en: "Double" },
    "http://www.w3.org/2001/XMLSchema#float": { en: "Float" },
    "http://www.w3.org/2001/XMLSchema#long": { en: "Long" },
    "http://www.w3.org/2000/01/rdf-schema#Literal": { en: "Literal" },
    "http://www.w3.org/2001/XMLSchema#nonNegativeInteger": { en: "NN Integer" }
};

export const NUMERIC_DATATYPES = [
    "http://www.w3.org/2001/XMLSchema#date",
    "http://www.w3.org/2001/XMLSchema#dateTime",
    "http://www.w3.org/2001/XMLSchema#integer",
    "http://www.w3.org/2001/XMLSchema#decimal",
    "http://www.w3.org/2001/XMLSchema#double",
    "http://www.w3.org/2001/XMLSchema#float",
    "http://www.w3.org/2001/XMLSchema#long"
];

export const DATATYPE_LIMITS = {
    "http://www.w3.org/2001/XMLSchema#date": {
        expression: "^\\d\\d\\d\\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])?$",
        maxLength: 10
    },
    "http://www.w3.org/2001/XMLSchema#integer": {
        expression: "^[\\-+]?[0-9]{0,15}$",
        maxLength: 16,
        minimumValue: "-999999999999999",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#nonNegativeInteger": {
        expression: "^[0-9]{0,15}$",
        maxLength: 16,
        minimumValue: "0",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#long": {
        expression: "^[\\-+]?[0-9]{0,15}$",
        maxLength: 16,
        minimumValue: "-999999999999999",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#decimal": {
        expression: "^[\\-+]?([0-9]+(\\.[0-9]+)?|\\.[0-9]+)$",
        maxLength: 16,
        minimumValue: "-999999999999999",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#double": {
        expression: "^[\\-+]?[0-9]+(\\.[0-9]+)?([Ee][+-]?[0-9]+)?$",
        maxLength: 16,
        minimumValue: "-999999999999999",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#float": {
        expression: "^[\\-+]?[0-9]+(\\.[0-9]+)?([Ee][+-]?[0-9]+)?$",
        maxLength: 16,
        minimumValue: "-999999999999999",
        maximumValue: "999999999999999"
    },
    "http://www.w3.org/2001/XMLSchema#anyURI": {
        maxLength: 1000,
        expression: "^(?:(?:https?|ftp):\\/\\/)(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\\.(?:[a-zA-Z\u00a1-\uffff]{2,})))(?::\\d{2,5})?(?:\\/\\S*)?$"
    }
};

export const MODULES = {
    TREAT_CONTENT_AS: 1,
    DATA_MANAGER: 2
};

export const MEDIA_TYPES_CONTENT = {
    "image/*": "An image URL (HTTPS)",
    "application/mathml+xml": "A MathML equation",
    "text/markdown": "Markdown compliant markup",
    "text/html": "An HTML fragment",
    "text/plain": "Multiline text",
    "image/svg+xml": "An SVG image (SVG/XML)"
};

// Application level entitlements
export const ENTITLEMENTS = {
    CAN_IMPORT: "https://graphifi.com/schema/entitlement/canImport",
    CAN_IMPORT_PROJECT: "https://graphifi.com/schema/entitlement/canImportProject",
    CAN_EXPORT_PROJECT: "https://graphifi.com/schema/entitlement/canExportProject",
    CAN_QUERY: "https://graphifi.com/schema/entitlement/canQuery",
    CAN_QUERY_PROJECT: "https://graphifi.com/schema/entitlement/canQueryProject",
    CAN_RUN_SAVED_QUERY: "https://graphifi.com/schema/entitlement/canRunSavedQuery",
    CREATE_GROUP: "https://graphifi.com/schema/entitlement/createGroup",
    EDIT_GROUP: "https://graphifi.com/schema/entitlement/editGroup",
    EDIT_INTEGRATION: "https://graphifi.com/schema/entitlement/editIntegration",
    EDIT_PERMISSIONS: "https://graphifi.com/schema/entitlement/editPermissions",
    EDIT_USER: "https://graphifi.com/schema/entitlement/editUser",
    MANAGE_INTEGRATION: "https://graphifi.com/schema/entitlement/manageIntegration",
    MANAGE_SAVED_QUERY: "https://graphifi.com/schema/entitlement/manageSavedQuery",
    MANAGE_SETTINGS: "https://graphifi.com/schema/entitlement/manageSettings",
    MANAGE_SNAPSHOTS: "https://graphifi.com/schema/entitlement/manageSnapshot",
    SYNCHRONISE_DATA: "https://graphifi.com/schema/entitlement/synchroniseData",
    VIEW_ENTITLEMENT: "https://graphifi.com/schema/entitlement/viewEntitlement",
    VIEW_SAVED_QUERY: "https://graphifi.com/schema/entitlement/viewSavedQuery",
};

export const DEFAULT_LANG = "en";

export const MAX_INTEGRATIONNAME_LENGTH = 50;
export const MAX_USERNAME_LENGTH = 50;
export const MAX_EMAIL_LENGTH = 250;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 50;
export const MAX_GIVENNAME_LENGTH = 50;
export const MAX_FAMILYNAME_LENGTH = 50;
export const MAX_USERGROUPNAME_LENGTH = 50;

export const MAX_PROJECT_TITLE_LENGTH = 100;
export const MAX_PROJECT_DESC_LENGTH = 500;

export const MAX_COMPONENT_TITLE_LENGTH = 100;
export const MAX_COMPONENT_DESC_LENGTH = 500;
export const MAX_DEFINITION_LENGTH = 5000;

export const MAX_LABEL_LENGTH = 200;
export const MAX_LITERAL_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 1000;
export const MAX_IRI_LENGTH = 100;
export const MAX_LONGIRI_LENGTH = 500;
export const MAX_TITLE_LENGTH = 100;
export const MAX_EXCLUDE_RESOURCES = 10000;
export const MAX_SUBSCRIPTIONS = 10000;

export const SAAS_MODE = "SAAS";
export const MANAGED_MODE = "MANAGED";

export const PANEL_WIDTH_NORMAL = 340;
export const PANEL_WIDTH_WIDE = 440;

export const MAX_COUNTER_VALUE = 10000000000;